module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-how-screenprint-4db5b2f0224524580098cf71bcb9ea23.svg";